/**
 * @typedef {import('../MapLibreMap.js').MLD} MLD
 */

/**
 * @typedef {Object} IMapBoundsOverlayProps
 */

window.OSM = window.OSM ?? {};
window.OSM.boundsOverlayIndex = 0;
OSM.MapBoundsOverlay = class MapBoundsOverlay {


    /** @type {OSM.MapLibreMap} */
    map;
    /** @type {MLD._LngLatBounds} */
    bounds;
    /** @type {IMapBoundsOverlayProps} */
    props;

    layerIDs = [];


    /**
     *
     * @param {OSM.MapLibreMap} map
     * @param {MLD._LngLatBounds} bounds
     * @param {IMapBoundsOverlayProps=} props
     */
    constructor(map, bounds, props) {
        this.map = map;
        this.bounds = bounds;
        this.props = props ?? {};
        this.initialize();
    }

    initialize(){

        const map = this.map.map;
        const bounds = this.bounds;

        const locationManager = OSM.manager.getLocationManager();
        const center = locationManager.getBoundsCenter(bounds);
        const cameraCenter = this.map.getCameraCenterForBounds(bounds);
        const overlayIndex = window.OSM.boundsOverlayIndex;
        window.OSM.boundsOverlayIndex ++;
        let layerID = "boundsOverlayRectangle"+overlayIndex;
        this.layerIDs.push(layerID);

        let north = bounds.getNorth();
        let south = bounds.getSouth();
        let east = bounds.getEast();
        let west = bounds.getWest();


        const northSouth = locationManager.normalisedNorthSouth(north, south);
        const eastWest = locationManager.normalisedEastWest(east, west);

        north = northSouth.north;
        south = northSouth.south;
        east = eastWest.east;
        west = eastWest.west;
        if(east < west) {
            east += 360;
        }

        let coordinates = [
            [west, north],
            [west, south],
            [east, south],
            [east, north],
            [west, north]
        ];
        map.addSource(layerID, {
            type: 'geojson',
            data: {
                type: 'Feature',
                properties: {},
                geometry: {
                    type: 'Polygon',
                    coordinates: [
                        coordinates
                    ]
                }
            }
        });
        map.addLayer({
            id: layerID,
            type: 'fill',
            source: layerID,
            layout: {},
            paint: {
                "fill-color": '#088',
                'fill-opacity': 0.3
            }
        });

        layerID = layerID = "boundsOverlayHorizontalLine"+overlayIndex;
        this.layerIDs.push(layerID);

        coordinates = [
            [west, center.lat],
            [east, center.lat]
        ];

        map.addSource(layerID, {
            type: 'geojson',
            data: {
                type: 'Feature',
                properties: {},
                geometry: {
                    type: 'LineString',
                    coordinates: coordinates
                }
            }
        });
        map.addLayer({
            id: layerID,
            type: 'line',
            source: layerID,
            layout: {
                'line-join': 'round',
                'line-cap': 'round'
            },
            paint: {
                'line-color': '#888',
                'line-width': 1
            }
        });

        layerID = layerID = "boundsOverlayVerticalLine"+overlayIndex;
        this.layerIDs.push(layerID);

        coordinates = [
            [center.lng, north],
            [center.lng, south]
        ];

        map.addSource(layerID, {
            type: 'geojson',
            data: {
                type: 'Feature',
                properties: {},
                geometry: {
                    type: 'LineString',
                    coordinates: coordinates
                }
            }
        });
        map.addLayer({
            id: layerID,
            type: 'line',
            source: layerID,
            layout: {
                'line-join': 'round',
                'line-cap': 'round'
            },
            paint: {
                'line-color': '#888',
                'line-width': 1
            }
        });
//*
        layerID = layerID = "boundsOverlayCameraHorizontalLine"+overlayIndex;
        this.layerIDs.push(layerID);

        coordinates = [
            [west, cameraCenter.lat],
            [east, cameraCenter.lat]
        ];

        map.addSource(layerID, {
            type: 'geojson',
            data: {
                type: 'Feature',
                properties: {},
                geometry: {
                    type: 'LineString',
                    coordinates: coordinates
                }
            }
        });
        map.addLayer({
            id: layerID,
            type: 'line',
            source: layerID,
            layout: {
                'line-join': 'round',
                'line-cap': 'round'
            },
            paint: {
                'line-color': '#1d5380',
                'line-width': 1
            }
        });
        //*/
    }

    removeFromMap(){
        for(let layerID of this.layerIDs){
            this.map.map.removeLayer(layerID)
            this.map.map.removeSource(layerID)
        }
    }

}